import { html, render } from "lit-html";
import connect from "../../../shared/data-store/connect";
import { store } from "./DataStore";
import { connect as connectDialog } from "../connect-with-dialog";
import { translate } from "../../../shared/l10n/translate";
import { FilterDialog } from "./FilterDialog";

customElements.define(
	"esc-filter-dialog-button",
	connectDialog(
		FilterDialog,
		class extends connect(HTMLElement, store) {
			update(_, { priceFiltersVisible }) {
				this.style.display = priceFiltersVisible ? "" : "none";
				render(
					html`<button>
						<i class="fa fa-sliders fa--space-after"></i>${translate(
							"filter_bar_label_filter_summary",
						)}
					</button>`,
					this,
				);
			}
		},
	),
);
